import styled from "styled-components"

export const ModalContent = styled.div`
  padding: 1rem;
`

export const ModalFooter = styled.div`
  padding: 1rem 2rem;
`